import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCapabilities } from "@/context/CapabilitiesContext";

/**
 * Guard component.
 *   - `roles`: user must effectively hold at least one of these (legacy).
 *   - `caps`:  user must have at least one of these capabilities (preferred for
 *              custom-role compatibility).
 * If both are given, either is sufficient.
 */
export default function ProtectedRoute({ children, roles, caps }) {
  const { user, checked } = useAuth();
  const { can, loaded: capsLoaded } = useCapabilities();

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (roles || caps) {
    // If gating by caps, wait until they load — else we'd bounce a legitimate user.
    if (caps && !capsLoaded) {
      return (
        <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground" data-testid="auth-loading">
          Loading…
        </div>
      );
    }
    const userRoles = user.roles && user.roles.length ? user.roles : [user.role];
    const roleOk = roles ? roles.some(r => userRoles.includes(r)) : false;
    const capOk = caps ? caps.some(k => can(k)) : false;
    if (!(roleOk || capOk)) return <Navigate to="/dashboard" replace />;
  }
  return children;
}
